var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6669 67.0002V61.4002H30.4576L66.0003 28.9482L61.6763 25.0002L26.1336 57.4522V39.0002H20.0003V67.0002H50.6669Z",
    fill: "#B2CE53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLeft);
export default __webpack_public_path__ + "static/media/DownLeft.6aaeaeb6e16587681a9c4e7535885d5e.svg";
export { ForwardRef as ReactComponent };